var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3007 9.70875C21.9107 9.31875 21.2807 9.31875 20.8907 9.70875L16.0007 14.5888L11.1107 9.69875C10.7207 9.30875 10.0907 9.30875 9.7007 9.69875C9.3107 10.0888 9.3107 10.7188 9.7007 11.1088L14.5907 15.9988L9.7007 20.8887C9.3107 21.2787 9.3107 21.9087 9.7007 22.2987C10.0907 22.6887 10.7207 22.6887 11.1107 22.2987L16.0007 17.4087L20.8907 22.2987C21.2807 22.6887 21.9107 22.6887 22.3007 22.2987C22.6907 21.9087 22.6907 21.2787 22.3007 20.8887L17.4107 15.9988L22.3007 11.1088C22.6807 10.7288 22.6807 10.0888 22.3007 9.70875Z",
    fill: "#052C42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.7f1def1f0189f835729e60955eeeeca3.svg";
export { ForwardRef as ReactComponent };